import { AxiosResponse } from 'axios';
import { instance } from './private';
import { DepositAddressDto, DepositsDto } from '../types/dto/Deposit.dto';

export const getDepositAddress = (): Promise<AxiosResponse<DepositAddressDto>> => instance.get('/v1/deposit-address');

export const getDeposits = (): Promise<AxiosResponse<DepositsDto>> => instance.get('/v1/deposits');
